<div class="container">
  <div class="close-icon">
    <button mat-icon-button (click)="snackBarRef.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="error-container">
  <p class="error-text">{{dialogData}}</p>
</div>
</div>